var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { MarketplaceFilterKey } from 'vrlcm-gui-types';
import { MARKETPLACE_PRODUCT_ID } from 'vrlcm-gui-constants';
import { isString } from '../util-functions';
export var mapMarketplaceFilterAPIResponse = function (apiData) {
    return {
        filters: [
            {
                value: MarketplaceFilterKey.Product,
                label: 'Product',
                options: Object.entries(apiData.productsMap).map(function (_a) {
                    var value = _a[0], label = _a[1];
                    return ({
                        value: value,
                        label: label
                    });
                }),
                searchable: false
            },
            {
                value: MarketplaceFilterKey.Category,
                label: 'Category',
                options: Object.entries(apiData.categoryMap).map(function (_a) {
                    var value = _a[0], label = _a[1];
                    return ({
                        value: value,
                        label: label
                    });
                }),
                searchable: true
            },
            {
                value: MarketplaceFilterKey.Publisher,
                label: 'Publisher',
                options: Object.entries(apiData.publisherMap).map(function (_a) {
                    var value = _a[0], label = _a[1];
                    return ({
                        value: value,
                        label: label
                    });
                }),
                searchable: true
            }
        ]
    };
};
function parseSemanticVersion(version) {
    var sm = {
        MAJOR: null,
        MINOR: null,
        PATCH: null,
        UNIVERSAL_MAJOR: false,
        UNIVERSAL_MINOR: false,
        UNIVERSAL_PATCH: false,
        DATA: version
    };
    if (version === '*') {
        sm.UNIVERSAL_MAJOR = true;
        return sm;
    }
    var semanticBreakup = version.split('.');
    if (semanticBreakup.length > 0) {
        sm.UNIVERSAL_MAJOR = false;
        if (semanticBreakup[0] === '*' || semanticBreakup[0] === 'x') {
            sm.UNIVERSAL_MAJOR = true;
        }
        else {
            sm.MAJOR =
                (semanticBreakup[0] ? parseInt(semanticBreakup[0], 10) : null) || null;
        }
        if (semanticBreakup[1] === '*' || semanticBreakup[1] === 'x') {
            sm.UNIVERSAL_MINOR = true;
        }
        else {
            sm.MINOR =
                (semanticBreakup[1] ? parseInt(semanticBreakup[1], 10) : null) || null;
        }
        if (semanticBreakup[2] === '*' ||
            semanticBreakup[2] === 'x' ||
            semanticBreakup[2] === undefined) {
            sm.UNIVERSAL_PATCH = true;
        }
        else {
            sm.PATCH =
                (semanticBreakup[2] ? parseInt(semanticBreakup[2], 10) : null) || null;
        }
    }
    return sm;
}
function compareSemanticVersions(sourceVersion, targetVersion) {
    var result = false;
    if (sourceVersion.UNIVERSAL_MAJOR) {
        result = true;
    }
    else {
        if (sourceVersion.MAJOR == null) {
            result = false;
        }
        else {
            sourceVersion.MAJOR = sourceVersion.MAJOR || 0;
            targetVersion.MAJOR = targetVersion.MAJOR || 0;
            sourceVersion.MINOR = sourceVersion.MINOR || 0;
            targetVersion.MINOR = targetVersion.MINOR || 0;
            sourceVersion.PATCH = sourceVersion.PATCH || 0;
            targetVersion.PATCH = targetVersion.PATCH || 0;
            if (sourceVersion.UNIVERSAL_MINOR) {
                result = sourceVersion.MAJOR === targetVersion.MAJOR;
            }
            else {
                if (sourceVersion.UNIVERSAL_PATCH) {
                    result =
                        sourceVersion.MAJOR === targetVersion.MAJOR &&
                            sourceVersion.MINOR === targetVersion.MINOR;
                }
                else {
                    result =
                        sourceVersion.MAJOR === targetVersion.MAJOR &&
                            sourceVersion.MINOR === targetVersion.MINOR &&
                            sourceVersion.PATCH === targetVersion.PATCH;
                }
            }
        }
    }
    return result;
}
var compareAgainstAllVersions = function (sourceVersions, targetVersion) {
    return sourceVersions.some(function (version) {
        return compareSemanticVersions(version, targetVersion);
    });
};
var filterEnvBasedOnContent = function (envRequest, item) {
    var envProductsWithAddedVro = __spreadArrays(envRequest.products).concat(envRequest.products
        .filter(function (p) { return p.id === 'vra'; })
        .map(function (p) { return (__assign(__assign({}, p), { id: 'vro' })); }));
    if (item.products.length === 0) {
        return envProductsWithAddedVro.some(function (p) { return p.id === item.productShortName; });
    }
    return item.products.some(function (ip) {
        var productVersions = [parseSemanticVersion(ip.productVersion)];
        return envProductsWithAddedVro.some(function (p) {
            return p.id ===
                (MARKETPLACE_PRODUCT_ID[ip.productShortName] || ip.productShortName) &&
                compareAgainstAllVersions(productVersions, parseSemanticVersion(p.version));
        });
    });
};
export var filterEnvironmentSelectionMetadataBasedOnContent = function (datacenters, envRequests, item) {
    return {
        dataCenters: datacenters
            .map(function (_a) {
            var dataCenterName = _a.dataCenterName, dataCenterVmid = _a.dataCenterVmid;
            return ({
                dataCenterVmid: dataCenterVmid,
                dataCenterName: dataCenterName,
                environments: envRequests
                    .filter(function (e) {
                    return e.infrastructure.properties.dataCenterVmid === dataCenterVmid &&
                        filterEnvBasedOnContent(e, item);
                })
                    .map(function (_a) {
                    var environmentId = _a.environmentId, environmentName = _a.environmentName, products = _a.products;
                    return ({
                        environmentId: environmentId,
                        environmentName: environmentName,
                        product: products.find(function (p) {
                            return item.products.some(function (ip) {
                                return ip.productShortName === p.id ||
                                    (ip.productShortName === 'vro' && p.id === 'vra');
                            });
                        })
                    });
                })
            });
        })
            .filter(function (dc) { return dc.environments.length > 0; })
    };
};
export var isMarketplaceJobSuccessful = function (taskResponse) { return (taskResponse ? taskResponse.status === 'SUCCESS' : false); };
export function extractMarketplaceSuccessData(taskResponse) {
    return taskResponse && isMarketplaceJobSuccessful(taskResponse)
        ? taskResponse.response
        : undefined;
}
export function extractMarketplaceErrors(taskResponse) {
    return taskResponse && taskResponse.status === 'FAILED'
        ? parseMarketplaceErrors(taskResponse)
        : undefined;
}
export function parseMarketplaceErrors(taskResponse) {
    if (taskResponse && taskResponse.response) {
        var parsedReponse = taskResponse.response;
        if (parsedReponse) {
            if (parsedReponse.errors && Array.isArray(parsedReponse.errors)) {
                return parsedReponse.errors.map(function (e) {
                    return isString(e) ? e : JSON.stringify(e);
                });
            }
            if (Array.isArray(parsedReponse)) {
                return parsedReponse.map(function (pr) {
                    return isString(pr) ? pr : JSON.stringify(pr);
                });
            }
            return [
                isString(parsedReponse) ? parsedReponse : JSON.stringify(parsedReponse)
            ];
        }
    }
}
